export default __webpack_public_path__ + "static/medical_gas_b.bbc185912847c1b53b03e4637eeaeb12.png";